import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../store/hooks';
import ConfirmationModal from '../../../../../core/components/confirmation-modal/ConfirmationModal';
import { AttachmentsCellProps } from '../../../../../core/types/coreTypes';
import {
  deleteCustomerAttachmentThunk,
  getCustomerAttachmentById,
} from '../../../../../store/thunks/customers/customersAttachmentsThunks';
import usePermission from '../../../../../permissions-handling/permissionHook';
import { PermissionEnum } from '../../../../../core/enums/dictionariesEnums';
import AttachmentsRow from '../../../../../common/components/attachments-table/AttachmentsRow';

const CustomerAttachCell: React.FC<AttachmentsCellProps> = ({
  attach,
  openEditModal,
  checked,
  checkRow,
}) => {
  const { id } = useParams();
  const allowedManage = usePermission(PermissionEnum.CustomerEditFields);

  const dispatch = useAppDispatch();
  const [isModal, setModal] = useState<boolean>(false);
  const actions = [
    {
      label: 'Edit comment',
      icon: <FontAwesomeIcon icon={faEdit} />,
      key: 'editComment',
      onClick: () => openEditModal(),
    },
    {
      label: 'Delete file',
      icon: <FontAwesomeIcon icon={faTrashAlt} />,
      key: 'deleteFile',
      onClick: () => setModal(true),
    },
  ];
  return (
    <>
      <ConfirmationModal
        isVisible={isModal}
        onCancel={() => setModal(false)}
        confirmHandler={() => id && dispatch(deleteCustomerAttachmentThunk({
          id: attach.id,
          customerId: +id,
          closeModal: () => setModal(false),
        }))}
      />
      <AttachmentsRow
        allowedManage={!!allowedManage}
        attachment={attach}
        checked={checked}
        checkRows={checkRow}
        onClick={(attachId) => id && dispatch(getCustomerAttachmentById({ customerId: +id, id: attachId }))}
        actions={actions}
      />
    </>
  );
};

export default CustomerAttachCell;
